import { render } from "./ProfileCardComp.vue?vue&type=template&id=3fe990dc&scoped=true"
import script from "./ProfileCardComp.vue?vue&type=script&lang=js"
export * from "./ProfileCardComp.vue?vue&type=script&lang=js"

import "./ProfileCardComp.vue?vue&type=style&index=0&id=3fe990dc&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe990dc"]])

export default __exports__